const sidebar = false;

const entity = {
  title: "Toolkits",
  actions: {
    sort: {
      endPoint: "toolkits/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "toolkits/by",
      query: {}
    },
    create: {
      endPoint: "toolkits"
    },
    filter: {
      endPoint: "toolkits/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  tooltip: "ID to generate this report",
  label: "Id",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "select",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "users/by",
      separator: " ",
      initializer: ""
    }
  }
},
{
  dataTableID: "title",
  tooltip: "Title of this toolkit",
  label: "Title",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "toolkits",
  endPoint: "toolkits/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};